import { icon } from 'leaflet';
import marker from './images/marker-icon.png';
import markerShadow from './images/marker-shadow.png';
import beltOk from '../../assets/images/VectorbeltOk.png';
import beltDanger from '../../assets/images/Vectorbelt.png';
import seatOk from '../../assets/images/VectorseatOk.png';
import seatDanger from '../../assets/images/Vectorseat.png';
/* 
image import example for icon url
import iconUrl from '../your-image-path'
*/
/*
for more information about icon https://leafletjs.com/reference.html#icon
*/
const exampleİcon = icon({
  iconUrl: 'path/to/your/image.png', // Resminizin URL'si
  iconSize: [38, 95], // İkonun boyutları
  iconAnchor: [22, 94], // İkonun hangi noktasının konumla eşleşeceğini belirtir
  popupAnchor: [-3, -76], // İkon üzerindeki popup'ın hangi noktaya bağlanacağını belirtir
});
const defaultIcon = L.icon({
  iconUrl: marker,
  iconSize: [25, 41],
  iconAnchor: [12.5, 41],
  shadowUrl: markerShadow,
  shadowSize: [41, 41],
  shadowAnchor: [12, 41],
});
const beltOkIcon = L.icon({
  iconUrl: beltOk,
  iconSize: [25, 41],
  iconAnchor: [12.5, 41],
  // shadowUrl: markerShadow,
  shadowSize: [41, 41],
  shadowAnchor: [12, 41],
});
const beltDangerIcon = L.icon({
  iconUrl: beltDanger,
  iconSize: [25, 41],
  iconAnchor: [12.5, 41],
  // shadowUrl: markerShadow,
  shadowSize: [41, 41],
  shadowAnchor: [12, 41],
});
const seatOkIcon = L.icon({
  iconUrl: seatOk,
  iconSize: [25, 41],
  iconAnchor: [12.5, 41],
  // shadowUrl: markerShadow,
  shadowSize: [41, 41],
  shadowAnchor: [12, 41],
});
const seatDangerIcon = L.icon({
  iconUrl: seatDanger,
  iconSize: [25, 41],
  iconAnchor: [12.5, 41],
  // shadowUrl: markerShadow,
  shadowSize: [41, 41],
  shadowAnchor: [12, 41],
});
export { beltOkIcon, beltDangerIcon, seatOkIcon, seatDangerIcon };
export { defaultIcon };
